// Order Status Constants - ใช้สีเดียวกันทั้งระบบ
export const ORDER_STATUS_CONFIG = {
  pending: {
    label: 'รออนุมัติ',
    color: '#FFD700',
    textColor: '#222222',
    variant: 'warning'
  },
  awaiting_payment: {
    label: 'รอชำระเงิน',
    color: '#00BFFF',
    textColor: '#FFFFFF',
    variant: 'info'
  },
  waiting_for_delivery: {
    label: 'กำลังจัดส่ง',
    color: '#9370DB',
    textColor: '#FFFFFF',
    variant: 'primary'
  },
  completed: {
    label: 'จัดส่งสำเร็จ',
    color: '#1DB954',
    textColor: '#FFFFFF',
    variant: 'success'
  },
  cancelled: {
    label: 'ยกเลิกโดยผู้ดูแล',
    color: '#000000',
    textColor: '#FFFFFF',
    variant: 'danger'
  },
  cancelled_by_customer: {
    label: 'ลูกค้ายกเลิก',
    color: '#FF6B6B',
    textColor: '#FFFFFF',
    variant: 'danger'
  }
};

// Helper function to get status config
export const getStatusConfig = (status) => {
  return ORDER_STATUS_CONFIG[status] || {
    label: status,
    color: '#666666',
    textColor: '#FFFFFF',
    variant: 'secondary'
  };
};

// สำหรับใช้ใน ORDER_STATUS_OPTIONS (AdminOrders)
export const ORDER_STATUS_OPTIONS = Object.entries(ORDER_STATUS_CONFIG).map(([value, config]) => ({
  value,
  label: config.label,
  color: config.color
}));
